import { Icon } from '@iconify/react';
import VisitorAvatar from './VisitorAvatar';
import { VisitorTypeBadge } from './VisitorBadges';
import { fmtPhone, isBlocked } from '../visitorConstants';

const VisitorProfileHeader = ({ visitor, canUpdate, canDelete, busy, onBlock, onEdit, onDelete }) => {
    const blocked = isBlocked(visitor);

    return (
        <div className="tw-p-5 tw-border-b tw-border-gray-100 tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-4">
            <div className="tw-flex tw-items-center tw-gap-3.5 tw-min-w-0">
                <VisitorAvatar visitor={visitor} size={64} />
                <div className="tw-min-w-0">
                    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                        <h1 className="tw-mb-0 tw-text-lg tw-font-bold tw-text-gray-800 tw-leading-snug">{visitor.name}</h1>
                        <VisitorTypeBadge value={visitor.visitor_type} />
                        {/* The blocked case already has a full banner above, so
                            only the reassuring state is repeated here. */}
                        {!blocked && (
                            <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold tw-bg-emerald-100 tw-text-emerald-700">
                                <Icon icon="mdi:check-circle-outline" className="tw-text-[9px]" />
                                Active
                            </span>
                        )}
                    </div>
                    <p className="tw-mb-0 tw-text-xs tw-text-gray-500 tw-mt-1 tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1">
                        <a
                            href={`tel:${visitor.phone}`}
                            className="tw-flex tw-items-center tw-gap-1 tw-font-mono tw-text-gray-700 hover:tw-text-sky-700"
                        >
                            <Icon icon="mdi:phone-outline" className="tw-text-gray-400" />
                            {fmtPhone(visitor.phone)}
                        </a>
                        {visitor.company_name && (
                            <span className="tw-flex tw-items-center tw-gap-1">
                                <Icon icon="mdi:domain" className="tw-text-gray-400" />
                                {visitor.company_name}
                            </span>
                        )}
                    </p>
                </div>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2">
                {canUpdate && !blocked && (
                    <button
                        onClick={onBlock}
                        disabled={busy}
                        className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-rose-700 tw-bg-white tw-border tw-border-rose-300 tw-rounded-md hover:tw-bg-rose-50 disabled:tw-opacity-50"
                    >
                        <Icon icon="mdi:block-helper" className="tw-text-base" />
                        Block
                    </button>
                )}
                {canUpdate && (
                    <button
                        onClick={onEdit}
                        className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-700 tw-bg-white tw-border tw-border-gray-300 tw-rounded-md hover:tw-bg-gray-50"
                    >
                        <Icon icon="mdi:pencil-outline" className="tw-text-base" />
                        Edit
                    </button>
                )}
                {canDelete && (
                    <button
                        onClick={onDelete}
                        className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-rose-700 tw-bg-white tw-border tw-border-rose-300 tw-rounded-md hover:tw-bg-rose-50"
                    >
                        <Icon icon="mdi:trash-can-outline" className="tw-text-base" />
                        Remove
                    </button>
                )}
            </div>
        </div>
    );
};

export default VisitorProfileHeader;
